import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";

const ProtectedRoute = ({ children, allowedRoles }) => {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="flex-center-all" style={{ height: "100vh", background: "#f8fafc", flexDirection: "column" }}>
        <div className="spinner" style={{ width: "40px", height: "40px", border: "4px solid #e2e8f0", borderTopColor: "#2563eb", borderRadius: "50%" }}></div>
        <p style={{ marginTop: "15px", color: "#64748b", fontFamily: "sans-serif" }}>Chargement de l'espace sécurisé...</p>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  if (allowedRoles && !allowedRoles.includes(user.role)) {
    // Redirect role to their own space
    if (user.role === "employee") return <Navigate to="/employee/dashboard" replace />;
    if (user.role === "manager") return <Navigate to="/manager/dashboard" replace />;
    if (user.role === "rh" || user.role === "admin") return <Navigate to="/rh/dashboard" replace />;
    return <Navigate to="/" replace />;
  }

  return children;
};

export default ProtectedRoute;
